<template>
  <div class="main-content main-wrap">
    <div class="normal-form">
    <h1>上传营业执照</h1>
    <el-upload class="licence-uploader" accept="image/jpeg, image/png" action="" :show-file-list="false"
      :on-success="onLicenceSuccess" :before-upload="beforeLicenceUpload">
      <img v-if="imageUrl" :src="imageUrl" class="licence">
      <i v-else class="el-icon-plus licence-uploader-icon"></i>
    </el-upload>
    <p class="help-text" style="margin: 20px 0;line-height: 22px;">
      为保障求职者利益，请上传营业执照。<br />
      营业执照只用于审核公司的真实性，审核通过后就可以对乐跳会员进行邀约了。<br />
      营业执照的公司抬头必须和所填的公司全称一致，否则会导致审核失败。<br />
      审核时间一般在一个工作日内。</p>
      <div>
        <el-button type="primary" :loading="saving" id="btnConfirm" @click="onSaveLicence">确定上传</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadLicence, saveLicenceToTemp } from '~/api/hr.js';
export default {
  data() {
    return {
      imageUrl: '',
      imageName: '',
      loading: null,
      saving: false,
    };
  },
  created() {
    this.$emit('changeMenu', '');
  },
  methods:{
    onLicenceSuccess(){
      this.closeLoading();
    },
    beforeLicenceUpload(file){
      this.loading = this.$loading({target: '.licence-uploader .el-upload'});
      var isImage = /^image/.test(file.type);
      if(!isImage){
        this.closeLoading();
        this.$message.error('上传失败，营业执照只支持图片格式（jpg、png）');
        return;
      }
      var isLt15M = file.size / 1024 / 1024 < 15;
      if(!isLt15M){
        this.closeLoading();
        this.$message.error('上传失败，营业执照图片大小不能超过15M');
        return;
      }
      this.uploadLicence(file);
    },
    uploadLicence(file){
      let imgFile = file;
      this.imgPreview(imgFile); 
    },
    //获取图片
    imgPreview(file) {
      // console.log(file);
      this.imageName = file.name;
      let self = this;
      //判断支不支持FileReader
      if (!file || !window.FileReader) return;
      
      //创建一个reader
      let reader = new FileReader();

      //将图片转成base64格式
      reader.readAsDataURL(file);
      //读取成功后的回调
      reader.onloadend = function () {
        let result = this.result; 
        let img = new Image();
        img.src = result;
        img.onload = function () {
          let data = self.compress(img);

          let blob = self.dataURItoBlob(data);

          var formData = new FormData();
          formData.append('image.jpg', blob);

          uploadLicence(formData).then(m => {
            self.closeLoading();
            if (m.errcode == 0) {
              self.imageUrl = m.data.src;
            } else {
              self.$message.error('营业执照上传失败，原因：' + m.errmsg);
            }
          }).catch(error => {
            self.$message.error('营业执照上传异常，原因：'+ error);
            self.closeLoading();
          });
        };
      };
    },
    // 压缩图片
    compress(img) {
      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');
      let initSize = img.src.length;
      let width = img.width;
      let height = img.height;

      var maxWidth = 1024,
        maxHeight = 1024;
        // 目标尺寸
      var targetWidth = width,
        targetHeight = height;
        // 图片尺寸超过1024 x 1024的限制
      if (width > maxWidth || height > maxHeight) {
        if (width / height > maxWidth / maxHeight) {
          // 更宽，按照宽度限定尺寸
          targetWidth = maxWidth;
          targetHeight = Math.round(maxWidth * (height / width));
        } else {
          targetHeight = maxHeight;
          targetWidth = Math.round(maxHeight * (width / height));
        }
      }

      canvas.width = targetWidth;
      canvas.height = targetHeight;
      // 铺底色
      ctx.fillStyle = '#fff';

      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      //进行最小压缩
      var compressRate = 1;
      if (initSize > 6 * 1024 * 1024) {
        compressRate = 0.7;
      } else if (initSize > 4 * 1024 * 1024) {
        compressRate = 0.8;
      } else if (initSize > 2 * 1024 * 1024) {
        compressRate = 0.9;
      }
      let ndata = canvas.toDataURL('image/jpeg', compressRate);
      return ndata;
    },
    // base64转成bolb对象
    dataURItoBlob(base64Data) {
      var byteString;
      if (base64Data.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(base64Data.split(',')[1]);
      else byteString = unescape(base64Data.split(',')[1]);
      var mimeString = base64Data
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {
        type: mimeString
      });
    },
    onSaveLicence(){
      if(!this.imageName || !this.imageUrl){
        this.$message.error('请先点击上面的 “+” 上传营业执照');
        return;
      }
      this.saving = true;
      var params = {
        file_name: this.imageName,
        licence: this.imageUrl,
      }; 
      saveLicenceToTemp(params).then( m => {
        this.saving = false;
        if(m.errcode === 0){
          this.$message.success('营业执照上传成功');
          this.$router.push('/VerifyWait');
        } else {
          this.$message.error('营业执照上传失败，原因：' + m.errmsg);
        }
      });
    },
    closeLoading(){
      if(this.loading){
        this.loading.close();
      }
    }
  }
};
</script>

<style scoped>
  
</style>